import React, { useEffect, useState } from "react";
import NavbarDashboard from "../components/Navbar/NavbarDashboard";
import Footer from "../components/footer/footer";
import { Link, useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db, logout, deleteAuthData, storage } from "../firebase";
import {
  query,
  collection,
  getDocs,
  where,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import { TextField } from "@mui/material";
import ADNU from "../assets/images/adnu_logo.png";
import { PiCarProfile } from "react-icons/pi";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faCar, faBus, faCity, faGasPump, faRandom } from '@fortawesome/free-solid-svg-icons';


const Profile = () => {
  const [user, loading, error] = useAuthState(auth);
  const [name, setName] = useState("");
  const [newName, setNewName] = useState("");
  const [isEditingName, setIsEditingName] = useState(false);
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const fetchUserName = async () => {
    try {
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const userDoc = await getDocs(q);
      const userData = userDoc.docs[0].data();
      setName(userData.name);
    } catch (err) {
      console.error(err);
      alert("An error occurred while fetching user data");
    }
  };

  const handleDeleteAccount = async () => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete your account? This action is irreversible, and your data cannot be retrieved."
    );

    if (isConfirmed) {
      try {
        // Delete user data from Firestore
        const userDocRef = doc(db, "users", user.uid);
        await deleteDoc(userDocRef);

        // Delete the user's authentication data
        await deleteAuthData();

        // Log out the user
        await logout();

        // Redirect to the home page or any other suitable location
        window.location.href = "/";
      } catch (error) {
        console.error("Error deleting user account:", error);
        // Handle the error, e.g., display an error message to the user
      }
    }
  };

  const updateUserName = async () => {
    try {
      const userDocRef = doc(db, "users", user.uid);
      await updateDoc(userDocRef, { name: newName });
      setName(newName);
      setIsEditingName(false); // Turn off editing mode after updating
    } catch (error) {
      console.error("Error updating user name:", error);
    }
  };

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
    fetchUserName();
    setEmail(user.email);
  }, [user, loading]);

  const [selectedIcon, setSelectedIcon] = useState(faUser);

    useEffect(() => {
      // Load the selected icon from local storage on component mount
      const storedIcon = localStorage.getItem('selectedIcon');
      if (storedIcon) {
        setSelectedIcon(JSON.parse(storedIcon));
      }
    }, []);
  
    const iconList = [faUser, faCar, faBus, faCity, faGasPump];
    const getRandomIcon = () => {
      const randomIndex = Math.floor(Math.random() * iconList.length);
      const randomIcon = iconList[randomIndex];
      setSelectedIcon(randomIcon);
      // Save the selected icon to local storage
      localStorage.setItem('selectedIcon', JSON.stringify(randomIcon));
    };


  return (
    <div className="container-dashboard">
      <NavbarDashboard />

      <div className="container-main-contents">
        <div className="container-main-header profile-container">
          <h1>Profile</h1>
          <div className="profile-picture-container">
            <FontAwesomeIcon icon={selectedIcon} size="8x" />
          </div>

          <button onClick={getRandomIcon} className="change_icon">
            <FontAwesomeIcon icon={faRandom} /> Change Profile Picture
          </button>

          <div className="profile-info-wrapper">
            <h2>{name}</h2>
            <p>{email}</p>
          </div>
        </div>

        <div className="lesson-content preferences-container">
          <div className="preferences-wrapper">
            <h1>Preferences</h1>

            <div className="preferences-wrapper-2">
              <h4 className="preferences-header">User Details</h4>
              <div className="details-ind">
                {isEditingName ? (
                  <>
                    <TextField
                      id="outlined-textarea"
                      className="login_textBox"
                      label="Name"
                      placeholder="Username"
                      style={{ witdh: 50 }}
                      inputProps={{ maxLength: 12 }}
                      margin="normal"
                      multiline
                      onChange={(e) => setNewName(e.target.value)}
                    />
                    <button onClick={updateUserName}>Confirm</button>
                  </>
                ) : (
                  <>
                    <p>Username: {name}</p>
                    <button onClick={() => setIsEditingName(true)}>
                      Edit Username
                    </button>
                  </>
                )}
              </div>
            </div>

            <div className="preferences-wrapper-2">
              <h4 className="preferences-header">User Details</h4>
              <div className="details-ind">
                <p>Email : {email}</p>
                <Link to="/resetemail">
                  <button>Change Email</button>
                </Link>
              </div>
            </div>

            <div className="preferences-wrapper-2">
              <h4 className="preferences-header">Security</h4>
              <div className="details-ind">
                <p>Password</p>
                <Link to="/resetpassword">
                  <button>Change Password</button>
                </Link>
              </div>
            </div>

            <div className="preferences-wrapper-2">
              <h4 className="preferences-header">Account Management</h4>
              <div className="details-ind">
                <p>Account Deletion</p>
                <div
                  className="delete-account-button"
                  onClick={handleDeleteAccount}
                >
                  Delete Account
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
